export const addNumberInputMaxLength = event => {
  if (event.currentTarget.maxLength <= event.currentTarget.value.length) {
    event.preventDefault();
  }
};